import IUserData from '../../../types/sign-in/IUserData'

export const SET_CURRENT_USER = 'sessionManager.setCurrentUser'
export const SET_IS_LOADING_CURRENT_USER = 'sessionManager.setIsLoadingCurrentUser'
export const RESET = 'sessionManager.reset'
export const SET_IS_MOUNTED = 'sessionManager.setIsMounted'
export const EXECUTE_LOGOUT = 'sessionManager.executeLogout'
export const SET_CALLBACK_URL = 'sessionManager.setCallbackUrl'

export function setCurrentUser(user: IUserData | null) {
  return {
    type: SET_CURRENT_USER,
    payload: user
  } as const
}

export function setIsLoadingCurrentUser(isLoadingCurrentUser: boolean) {
  return {
    type: SET_IS_LOADING_CURRENT_USER,
    payload: isLoadingCurrentUser
  } as const
}

export function setIsMounted(payload: boolean) {
  return {
    type: SET_IS_MOUNTED,
    payload
  }
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export function executeLogout() {
  return {
    type: EXECUTE_LOGOUT,
    payload: {}
  } as const
}

export function setCallbackUrl(payload: boolean) {
  return {
    type: SET_CALLBACK_URL,
    payload
  } as const
}

export type SessionManagerAction = ReturnType<
  | typeof setCurrentUser
  | typeof reset
  | typeof setIsLoadingCurrentUser
  | typeof setIsMounted
  | typeof executeLogout
  | typeof setCallbackUrl
>
